var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAllProperties = function SvgAllProperties(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.34 10.286-5.688-5.69a3.756 3.756 0 0 0-5.304 0l-5.689 5.69A2.234 2.234 0 0 0 3 11.876v7.363a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 19.24v-7.363a2.234 2.234 0 0 0-.66-1.59Zm-6.09 9.703h-4.5v-2.95a2.25 2.25 0 0 1 4.5 0v2.95Zm5.25-.75a.75.75 0 0 1-.75.75h-3v-2.95a3.75 3.75 0 1 0-7.5 0v2.95h-3a.75.75 0 0 1-.75-.75v-7.363c0-.198.08-.389.22-.53l5.689-5.687a2.256 2.256 0 0 1 3.182 0l5.69 5.69c.139.14.218.33.219.527v7.363Z"
  })));
};
export default SvgAllProperties;